import { useEffect, useState } from "react";
import { Logo } from "@/components/atoms/Logo";
import { resolveLogoDisplayUrl } from "@/lib/logoUpload";

interface PropertyThumbnailImageProps {
  urls: string[] | undefined;
  fallbackLogoUrl: string;
  alt: string;
  fallbackLogoSize: number;
}

export function PropertyThumbnailImage({
  urls,
  fallbackLogoUrl,
  alt,
  fallbackLogoSize,
}: PropertyThumbnailImageProps) {
  const [index, setIndex] = useState(0);
  const [fallbackFailed, setFallbackFailed] = useState(false);
  const propertyUrls = urls ?? [];
  const resolvedFallbackLogoUrl = resolveLogoDisplayUrl(fallbackLogoUrl) ?? "";
  const key = `${propertyUrls.join("|")}|${resolvedFallbackLogoUrl}`;

  useEffect(() => {
    setIndex(0);
    setFallbackFailed(false);
  }, [key]);

  const src = propertyUrls[index];

  if (!src) {
    if (fallbackFailed || !resolvedFallbackLogoUrl) {
      return (
        <div className="flex h-full w-full items-center justify-center bg-slate-100">
          <Logo size={fallbackLogoSize} />
        </div>
      );
    }

    return (
      <div className="flex h-full w-full items-center justify-center bg-slate-100">
        <img
          src={resolvedFallbackLogoUrl}
          alt={alt}
          loading="lazy"
          className="rounded-[10px] object-contain"
          style={{ width: fallbackLogoSize, height: fallbackLogoSize }}
          onError={() => setFallbackFailed(true)}
        />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="h-full w-full object-cover"
      onError={() => setIndex((current) => current + 1)}
    />
  );
}
